import DateSchema from "_shared/dates/date-schema";
import EntityMemberSchema from "_shared/entity-members/entity-member-schema";
import GuidSchema from "_shared/guids/guid-schema";
import { z } from "zod";

export type ActiveTeamJSON = z.infer<typeof ActiveTeamSchema.ActiveTeamJSONZ>;

/** Which side of the work a team is on, as the API's `ActiveTeamSide` names it. */
export type ActiveTeamSide = z.infer<typeof ActiveTeamSchema.ActiveTeamSideZ>;

/** Why a team is on the reader's Teams page, as the API's `ActiveTeamPerspective` names it. */
export type ActiveTeamPerspective = z.infer<typeof ActiveTeamSchema.ActiveTeamPerspectiveZ>;

/**
 * A row of the Teams page, as `GET work/active-teams` sends it: the team, the agreement it is on
 * (#4441), when that work was hired, which the page shows and sorts on (#5441), and the side the
 * team is on and why it is listed (#6557).
 */
export default class ActiveTeamSchema {
  public static readonly ActiveTeamSideZ = z.enum(["Vendor", "Client"]);

  public static readonly ActiveTeamPerspectiveZ = z.enum(["On", "WorkingForMe"]);

  public static readonly ActiveTeamJSONZ = z.object({
    leader: EntityMemberSchema.EntityMemberJSONZ.nullish(),
    members: z.array(EntityMemberSchema.EntityMemberJSONZ).optional(),
    marketplaceId: GuidSchema.GuidJSONZ.nullish(),
    workAgreementId: GuidSchema.GuidJSONZ,
    workAgreementName: z.string(),
    // Which version of the work the agreement is (#6636). Absent from a payload older than the field.
    versionNumber: z.number().int().positive().nullish(),
    hireDate: DateSchema.DateJSONZ,
    side: ActiveTeamSchema.ActiveTeamSideZ,
    perspectives: z.array(ActiveTeamSchema.ActiveTeamPerspectiveZ),
  });
}
